import { Route, Routes } from "react-router-dom";
import Login from "../Pages/Login";
import LoginPassword from "../Pages/LoginPassword";
import Register from "../Pages/Register";
import ForgetPassword from "../Pages/ForgetPassword";
import OneTimePassword from "../Pages/OneTimePassword";
import UploadFile from "../Pages/UploadFile";
import Verification from "../Pages/Verification";

const UnAuthenticated = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/loginPassword" element={<LoginPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verification" element={<Verification />} />
            <Route path="/forgetPassword" element={<ForgetPassword />} />
            <Route path="/oneTimePassword" element={<OneTimePassword />} />
            <Route path="/" element={<UploadFile />} />
            <Route path="*" element={<UploadFile />} />
        </Routes>
    )

}

export default UnAuthenticated;